import { render } from "./environment-card.vue?vue&type=template&id=b46262ac&scoped=true"
import script from "./environment-card.vue?vue&type=script&lang=ts"
export * from "./environment-card.vue?vue&type=script&lang=ts"

import "./environment-card.vue?vue&type=style&index=0&id=b46262ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b46262ac"

export default script